<template>
  <div>
    <v-card>
      <v-toolbar flat color="white">
        <v-toolbar-title>Payable Entity Tax Data</v-toolbar-title>
        <v-spacer />
        <v-btn icon style="float:left" @click.native.stop="searchBegin">
          <v-icon>search</v-icon>
        </v-btn>
        <div :class="{'searching--closed': !searching}" class="searching">
          <v-text-field id="searchGroup" v-model="keywordSearch" autocomplete="off" append-icon="close" placeholder="Filter..." hide-details single-line @click:append="searchEnd" />
        </div>
      </v-toolbar>

      <v-data-table :headers="headers" :items="listData" :pagination.sync="pagination" :total-items="totalRecords" :loading="loading" class="elevation-1" :rows-per-page-items="rowsPerPageItems">
        <v-progress-linear slot="progress" color="secondary" indeterminate />
        <template slot="items" slot-scope="props">
          <td>{{ props.item.id }}</td>
          <td>{{ props.item.firstName }}</td>
          <td>{{ props.item.lastName }}</td>

          <td class="text-xs-center">
            <v-icon v-if="props.item.canBePaid" color="green">
              fas fa-check
            </v-icon>
            <v-icon v-if="!props.item.canBePaid" color="red">
              fas fa-times
            </v-icon>
          </td>

          <td class="text-xs-center">
            <w9-column :data="props.item" @getListData="getListData" />
          </td>

          <td class="text-xs-center">
            <v-btn icon @click="showUpdateTaxDialog(props.item)">
              <v-icon>
                far fa-edit
              </v-icon>
            </v-btn>
          </td>

          <td class="text-xs-center">
            <v-btn v-if="props.item.canBePaid" icon @click.native="showPayrollColumnDialog(props.item)">
              <v-icon>
                fas fa-file-invoice-dollar
              </v-icon>
            </v-btn>
            <v-icon v-if="!props.item.canBePaid" color="red">
              fas fa-times
            </v-icon>
          </td>

          <td class="text-xs-center">
            <v-btn v-if="props.item.canBePaid" icon @click.native="showPayReportDialog(props.item)">
              <v-icon>
                fas fa-file-export
              </v-icon>
            </v-btn>
            <v-icon v-if="!props.item.canBePaid" color="red">
              fas fa-times
            </v-icon>
          </td>
        </template>
      </v-data-table>
    </v-card>

    <payroll-column :data="selectedUser" :dialog.sync="payrollColumnDialog" @getListData="getListData" />
    <update-tax-data :data="selectedUser" :dialog.sync="updateTaxDialog" @getListData="getListData" />
    <pay-report-column :data="selectedUser" :dialog.sync="payReportDialog" @getListData="getListData" />
  </div>
</template>

<script>
  import axios from 'axios';
  import UpdateTaxData from './vue-components/UpdateTaxData.vue';
  import W9Column from './vue-components/W9Column.vue';
  import PayReportColumn from './vue-components/PayReportColumn.vue';
  import PayrollColumn from './vue-components/PayrollColumn.vue';

  export default {
    parent: true,

    components: {
      UpdateTaxData,
      W9Column,
      PayReportColumn,
      PayrollColumn,
    },

    data: () => ({
      loading: true,
      searching: false,
      keywordSearch: '',
      listData: [],
      totalRecords: 0,
      rowsPerPageItems: [20, 50, 75, 100],
      pagination: {
        descending: false, page: 1, rowsPerPage: 20, sortBy: 'id', totalItems: 0,
      },
      headers: [
        { text: 'ID #', align: 'left', value: 'id' },
        { text: 'First Name', value: 'firstName', align: 'left' },
        { text: 'Last Name', value: 'lastName', align: 'left' },
        {
          text: '1099 Ready', value: 'w9Url', align: 'center', sortable: false,
        },
        {
          text: 'W9', value: '', align: 'center', sortable: false,
        },
        {
          text: 'Edit', value: '', align: 'center', sortable: false,
        },
        {
          text: 'Payroll', value: '', align: 'center', sortable: false,
        },
        {
          text: 'Pay Report', value: '', align: 'center', sortable: false,
        },
      ],

      selectedUser: null,
      payReportDialog: false,
      updateTaxDialog: false,
      payrollColumnDialog: false,
    }),

    watch: {
      pagination: {
        handler() {
          this.getListData();
        },
        deep: true,
      },

      keywordSearch() {
        this.getListData();
      },
    },

    mounted() {
      this.getListData();
    },

    methods: {
      async getListData() {
        const {
          sortBy, descending, page, rowsPerPage,
        } = this.pagination;

        this.loading = true;
        const { data } = await axios.get(`/api/human-resources/payable-entity-tax-data/list?currentPage=${page}&pageSize=${rowsPerPage}&searchTerm=${this.keywordSearch}`);
        this.listData = data.resultItems;
        this.totalRecords = data.totalRecords;
        this.loading = false;
      },

      searchBegin() {
        this.searching = true;
        setTimeout(() => document.querySelector('#searchGroup').focus(), 50);
      },

      searchEnd() {
        this.searching = false;
        this.keywordSearch = '';
        document.querySelector('#searchGroup').blur();
      },

      showPayReportDialog(user) {
        this.payReportDialog = true;
        this.selectedUser = user;
      },

      showUpdateTaxDialog(user) {
        this.updateTaxDialog = true;
        this.selectedUser = user;
      },

      showPayrollColumnDialog(user) {
        this.payrollColumnDialog = true;
        this.selectedUser = user;
      },
    },
  };
</script>